import { FC, Children } from 'react'
import Image from 'next/image'
import clsx from 'clsx'
import { Swiper, SwiperSlide } from 'swiper/react'

import { STATIC_URL } from 'constants/data'

import styles from './swiper-simple.module.scss'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
import 'swiper/css/effect-creative'
import 'swiper/css/scrollbar'

const arrowDefault = {
  src: `${STATIC_URL}/icons/arrow.svg`,
  alt: 'arrow',
  width: 16,
  height: 16,
}
const SwiperSimple: FC<{
  id: string
  swiperProps: any
  swiperMod?: string
  disableNav?: boolean
  disablePagination?: boolean
  navWrapMod?: string
  arrowImg?: {
    src: string
    alt: string
    width: number
    height: number
  }
}> = ({
  id,
  children,
  swiperProps,
  swiperMod,
  navWrapMod,
  disableNav = false,
  disablePagination = false,
  arrowImg,
}) => {
  const childrenWrapped = Children.map(children, (child) => {
    return <SwiperSlide className={styles.slide}>{child}</SwiperSlide>
  })
  const arrow = arrowImg ? arrowImg : arrowDefault
  return (
    <>
      <Swiper
        {...swiperProps}
        className={clsx({
          [swiperMod as string]: swiperMod,
        })}
        key={id}
      >
        {childrenWrapped}
      </Swiper>

      <div
        className={clsx(styles.navWrap, {
          [navWrapMod as string]: navWrapMod,
        })}
      >
        <div
          className={clsx(styles.pagination, {
            [styles.hide]: disablePagination,
          })}
          id={`pagination-${id}`}
        />

        <div
          className={clsx(styles.btnsWrap, {
            [styles.hide]: disableNav,
          })}
        >
          <button className={clsx(styles.arrow, styles.arrowLeft)} id={`nav-left-${id}`}>
            <Image {...arrow} />
          </button>

          <button className={clsx(styles.arrow, styles.arrowRight)} id={`nav-right-${id}`}>
            <Image {...arrow} />
          </button>
        </div>
      </div>
    </>
  )
}

export default SwiperSimple
